import {useMemo} from 'react';
import {AudioItem} from './AudioItem';
import {HiveAudiosHead, HiveAudiosLink, HiveAudiosTitle, HiveAudiosWrapper} from './styles';
import {ChevronRightIcon, MicrophoneIcon} from 'shared/ui/icons';
import type {HiveSoundsItem} from '../../../entities/hiveSound/model/types.ts';
import {Button} from '@atomaro/ui-kit';
import {
  ChartPlaceholderText,
  ChartPlaceholderWrapper,
} from '../../../features/hive/ui/HiveBodyAnalytics/AnalyticsCard.tsx';
import {TgIcon} from '../../../shared/ui/icons';
import {utcToUserDate} from 'features/calendar/helpers/dates.ts';
import {Pagination, PaginationProps} from 'widgets/pagination/ui/Pagination.tsx';

type HiveAudiosProps = {
  isWidget?: boolean;
  audioRecords: HiveSoundsItem[];
  pagination?: PaginationProps;
};

export const HiveAudios = (props: HiveAudiosProps) => {
  const {isWidget = false, audioRecords, pagination} = props;

  const audios = useMemo(() => {
    return audioRecords.map(
      (audioRecord) => `/collector/audio-records/stream/${audioRecord.fileName}`
    );
  }, [audioRecords]);

  return (
    <HiveAudiosWrapper className="hiveAudios" $isVidget={isWidget}>
      {isWidget && (
        <HiveAudiosHead>
          <HiveAudiosTitle>
            <MicrophoneIcon />
            <span>Звуки в ульях</span>
          </HiveAudiosTitle>
          <HiveAudiosLink to="/hive-audios">
            <span>Все записи</span>
            <ChevronRightIcon />
          </HiveAudiosLink>
        </HiveAudiosHead>
      )}
      {audios.length > 0 ? (
        <>
          {audios.map((audio, index) => (
            <AudioItem
              src={audio}
              key={index}
              name="asd"
              date={utcToUserDate(audioRecords[index].createdAt)}
              hiveNumber={audioRecords[index].hiveNumber}
            />
          ))}
          {pagination && (
            <Pagination
              page={pagination.page}
              totalPages={pagination.totalPages}
              onChange={pagination.onChange}
            />
          )}
        </>
      ) : (
        <ChartPlaceholderWrapper>
          <ChartPlaceholderText>Покупайте наши устройства</ChartPlaceholderText>
          <Button
            label="Написать нам"
            variant="primary"
            size="l"
            iconPrefix={<TgIcon />}
            onClick={() => window.open('https://t.me/Hive_Technical_support_bot')}
          />
        </ChartPlaceholderWrapper>
      )}
    </HiveAudiosWrapper>
  );
};
